// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6TvED","projectCategory":"styles_projectCategory__5hWT4"};